// @flow
import { SeaFlagActionTypes } from './constants';

type SeaFlagAction = { type: string, payload: {} | string };

// common success
export const seaFlagApiResponseSuccess = (actionType: string, data: any): SeaFlagAction => ({
    type: SeaFlagActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const seaFlagApiResponseError = (actionType: string, error: string): SeaFlagAction => ({
    type: SeaFlagActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getSeaFlags = (id: string): SeaFlagAction => ({
    type: SeaFlagActionTypes.GET_SEA_FLAG,
    payload: { id },
});

export const addSeaFlags = (seaFlags:any):SeaFlagAction=>({
    type:SeaFlagActionTypes.ADD_SEA_FLAG,
    payload:seaFlags
})
export const updateSeaFlags = (seaFlags:any):SeaFlagAction=>({
    type:SeaFlagActionTypes.UPDATE_SEA_FLAG,
    payload:seaFlags
})
export const deleteSeaFlags = (id:string):SeaFlagAction=>({
    type:SeaFlagActionTypes.DELETE_SEA_FLAG,
    payload:{id}
})

export const listSeaFlags = (params:any): SeaFlagAction => ({
    type: SeaFlagActionTypes.LIST_SEA_FLAGS,
    payload: params,
});

export const setFiltersSeaFlags = (params:any): SeaFlagAction => ({
    type: SeaFlagActionTypes.SET_FILTER,
    payload: params,
})

export const resetSeaFlags = (): SeaFlagAction => ({
    type: SeaFlagActionTypes.RESET,
    payload: {},
});

